<template>
  <div class="UnSearchCenter pad-btm15 container" ref="container">
    <div class="content">
      <!-- 内容精选 -->
      <div v-if="h5ContentList.length !== 0 || !isLoadH5ContentList" class="carefullyChosen">
        <div class="customTitle">内容精选</div>
        <div class="carefullyChosenList">
          <carefully-chosen-item v-for="(item, index) in h5ContentList" :key="index" :itemInfo="item" class="CarefullyChosenItem" @linkToDetail="linkToDetailH5Content"></carefully-chosen-item>
          <div class="checkMoreBox tapActive" @click="$router.push({ name: 'carefullyChosenPage' })">
            <div class="subCon">查看更多<van-icon name="arrow" class="arrowIcon" /></div>
          </div>
        </div>
      </div>
      <!-- 淘礼金商品列表 -->
      <div class="modelThree" v-show="!partOneData.isLoad || partOneData.list.length > 0">
        <div class="customTitle">补贴专区</div>
        <div class="modelThreeTitle">
          <van-image fit="cover" class="clockIcon" :src="require('@/assets/image/icon1.png')" />
          <div class="time">每日 10:00 上新补贴商品</div>
        </div>
        <div class="listPart">
          <van-list
            v-model="partOneData.loading"
            :finished="partOneData.finished"
            finished-text="没有更多商品啦"
            @load="GetTLJProductList"
            :error.sync="partOneData.error"
            :immediate-check="false"
            error-text="请求失败，点击重新加载"
          >
            <div class="waterfallList">
              <div class="hot-block">
                <div v-for="(item, index) in partOneData.list" :key="index" class="hot-block-item">
                  <goods-item2 v-if="index % 2 === 0" :goodsInfo="item" @entotTLJDetailPage="entotTLJDetailPage"></goods-item2>
                </div>
              </div>
              <div class="hot-block">
                <div v-for="(item, index) in partOneData.list" :key="index" class="hot-block-item">
                  <goods-item2 v-if="index % 2 === 1" :goodsInfo="item" @entotTLJDetailPage="entotTLJDetailPage"></goods-item2>
                </div>
              </div>
            </div>
          </van-list>
          <div class="list" v-show="!partOneData.isLoad && !partOneData.error && !partOneData.finished">
            <goods-item2-skeleton v-for="subIndex in 4" :key="subIndex"></goods-item2-skeleton>
          </div>
        </div>
      </div>
      <!-- 原有领券商品列表 -->
      <!-- <div ref="listPart2" class="listPart2" v-if="isShowCollectCouponsPart">
        <div class="customTitle">领券专区</div>
        <div ref="vanTabsBox">
          <van-tabs @change="changeTab" v-model="active" :before-change="beforeChange" line-width="30px" line-height="5px" color="#f54e66" sticky>
            <van-tab v-for="(item, index) in datalist" :key="index">
              <template #title>
                <span :style="active === index ? 'fontWeight: 700' : ''" style="fontsize: 15px">{{ item.labelName }}</span>
              </template>
              <div class="tabsBannerBox">
                <van-image class="tabsBanner" src="http://youp-read.leqilucky.com/upaiyun/Sys/20211025/5003365252613446391.png" @click="searchPageShow = true" />
              </div>
              <van-list
                v-model="item.loading"
                :finished="item.finished"
                finished-text="没有更多商品啦"
                @load="onLoad"
                :error.sync="item.error"
                :immediate-check="false"
                error-text="请求失败，点击重新加载"
              >
                <div class="list">
                  <goods-item v-for="(subItem, subIndex) in item.tempList" :key="subIndex" :goodsInfo="subItem" @tapEvent="linkToGoodsDetail"></goods-item>
                </div>
              </van-list>
              <div class="seizeAaSeat" v-show="!item.isLoad && !item.error && !item.finished">
                <div class="list">
                  <goods-item v-for="subIndex in 6" :key="subIndex"></goods-item>
                </div>
              </div>
              <div class="emptyBox"></div>
            </van-tab>
          </van-tabs>
        </div>
      </div> -->
    </div>
    <search-page v-if="searchPageShow" ref="searchPageRef" @goSearchResult="goSearchResult" @searchResult="searchResult" @hideInput="hideInput"> </search-page>
    <!-- 返回顶部 -->
    <quick-top @returnTop="returnTop" :isReturn="isReturn"></quick-top>
  </div>
</template>

<script>
import searchPageMixins from '@/mixins/searchPageMixins'
import { mapGetters, mapMutations } from 'vuex'
import { Image as VanImage, Tab, Tabs, List, Icon } from 'vant'
import ModelTwo from './children/ModelTwo.vue'
import GoodsItem from './children/GoodsItem.vue'
import GoodsItem2 from './children/GoodsItem2.vue'
import GoodsItem2Skeleton from './children/GoodsItem2Skeleton.vue'
import SearchPage from '@/components/smartComponent/SearchPage'
import { Indicator } from 'mint-ui'
import QuickTop from '@/components/smartComponent/QuickTop'
import CarefullyChosenItem from './children/CarefullyChosenItem.vue'
import { TBKProductListV2, GetTBKProductInfoSuper, GetTBKProductInfoSuperNologin, GetTLJProductList, H5ContentListGet } from '@/api/souhuo'
export default {
  name: 'UnSearchCenter',
  mixins: [searchPageMixins],
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab,
    'van-list': List,
    'van-icon': Icon,
    VanImage,
    ModelTwo,
    GoodsItem,
    GoodsItem2,
    GoodsItem2Skeleton,
    SearchPage,
    QuickTop,
    CarefullyChosenItem
  },
  data() {
    return {
      active: 0,
      datalist: [
        {
          TbkMaterialType: 0,
          labelName: '热门推荐',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        },
        {
          TbkMaterialType: 1,
          labelName: '鞋包服饰',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        },
        {
          TbkMaterialType: 2,
          labelName: '食品日用',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        },
        {
          TbkMaterialType: 3,
          labelName: '家居电器',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        }
      ],
      recordTabScrollTopList: [0, 0, 0, 0], // 记录每一项滚动的位置
      scrollY: 0, // 定义初始滚动高度
      isShowCollectCouponsPart: false, // 是否展示领券专区
      isReturn: false,
      container: null,
      partOneData: {
        list: [],
        loading: false,
        finished: false,
        error: false,
        page: 1,
        isLoad: false
      },
      isLoadH5ContentList: false,
      h5ContentList: [
        {
          MainPicUrl: '',
          Title: '',
          CreateTime: '',
          ReadCount: '',
          LikeCount: ''
        },
        {
          MainPicUrl: '',
          Title: '',
          CreateTime: '',
          ReadCount: '',
          LikeCount: ''
        }
      ] // 内容列表
    }
  },

  computed: {
    ...mapGetters(['loginState', 'getIsAuthorized', 'getIsApp'])
  },

  mounted() {
    this.$nextTick(() => {
      this.container = this.$refs.container
      this.$refs.container.addEventListener('scroll', this.handleScroll)
    })
  },

  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW']),
    async onLoad() {
      await this.fetchData()
    },
    async reFetchPage() {
      this.active = 0
      this.datalist = [
        {
          TbkMaterialType: 0,
          labelName: '热门推荐',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        },
        {
          TbkMaterialType: 1,
          labelName: '鞋包服饰',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        },
        {
          TbkMaterialType: 2,
          labelName: '食品日用',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        },
        {
          TbkMaterialType: 3,
          labelName: '家居电器',
          tempList: [],
          page: 1,
          loading: false,
          finished: false,
          isLoad: false,
          error: false,
          scrollTo: 0
        }
      ]
      this.partOneData = {
        list: [],
        loading: false,
        finished: false,
        error: false,
        page: 1,
        isLoad: false
      }
      this.scrollY = 0
      this.isReturn = false
      // Indicator.open({
      //   text: "加载中",
      //   spinnerType: "triple-bounce",
      // });
      this.partOneData.loading = true
      await this.GetH5ContentList()
      this.GetTLJProductList()
    },
    // 返回顶部
    returnTop() {
      this.$refs.container.scrollTop = 0
    },
    handleScroll() {
      // 滚动高度
      let scrollTop = this.$refs.container.scrollTop
      this.pageScrollTop = scrollTop
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
    },
    // 当前激活的标签改变时触发
    changeTab() {
      this.$nextTick(async () => {
        this.$refs.container.scrollTop = this.recordTabScrollTopList[this.active]
        let currentObj = this.datalist[this.active]
        if (!currentObj.isLoad) {
          await this.fetchData()
        }
      })
    },
    // 切换标签前的回调函数，返回 false 可阻止切换，支持返回 Promise
    beforeChange() {
      let listPart2OffsetTop = this.$refs.listPart2.offsetTop
      let isSticky = this.$refs.container.scrollTop >= listPart2OffsetTop
      this.recordTabScrollTopList.forEach((val, index) => {
        if (isSticky && val < listPart2OffsetTop) {
          this.recordTabScrollTopList[index] = listPart2OffsetTop
        }
        if (!isSticky) {
          // 滚动距离不大于tab栏距离顶部距离
          this.recordTabScrollTopList[index] = this.$refs.container.scrollTop
        }
      })
      this.recordTabScrollTopList[this.active] = this.$refs.container.scrollTop
      console.log(this.recordTabScrollTopList)
      return true
    },
    // 自动模式下数据获取+
    fetchData() {
      let currentObj = this.datalist[this.active]
      if (currentObj.finished) return
      let params = {
        page: currentObj.page,
        TbkMaterialType: currentObj.TbkMaterialType
      }
      return TBKProductListV2(params)
        .then((res) => {
          Indicator.close()
          let resDataList = res.DataList.filter((item) => item.CouponBeginDate)
          currentObj.tempList = [...currentObj.tempList, ...resDataList]
          currentObj.page++
          currentObj.loading = false
          if (!currentObj.isLoad) {
            currentObj.isLoad = true
          }
          // IsBottom为true说明是最后一页数据
          if (res.IsBottom) {
            currentObj.finished = true
            this.refreshing = false
            return
          }
        })
        .catch(() => {
          Indicator.close()
          currentObj.loading = false
          currentObj.error = true
          currentObj.refreshing = false
        })
    },
    // 进入免搜详情页
    linkToGoodsDetail(goodsDetailData) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      // 此提交的字段刚好和免搜商品的字段对应
      let postData = {
        NumId: goodsDetailData.NumId,
        ProductName: goodsDetailData.ProductName,
        ProductHeadUrl: goodsDetailData.ProductHeadUrl,
        ProductDetailUrl: goodsDetailData.ProductDetailUrl,
        ProductPrice: goodsDetailData.ProductPrice,
        ProductSaleCount: goodsDetailData.ProductSaleCount,
        InComeRate: goodsDetailData.InComeRate,
        PlatformNo: goodsDetailData.PlatformNo,
        TBKUrl: goodsDetailData.TBKUrl,
        TKLWord: goodsDetailData.TKLWord,
        CouponId: goodsDetailData.CouponId,
        CouponTotal: goodsDetailData.CouponTotal,
        CouponResidue: goodsDetailData.CouponResidue,
        CouponAmount: goodsDetailData.CouponAmount,
        CouponBeginDate: new Date(parseInt(goodsDetailData.CouponBeginDate.replace(/\D/gi, ''))),
        CouponEndDate: new Date(parseInt(goodsDetailData.CouponEndDate.replace(/\D/gi, ''))),
        CouponUrl: goodsDetailData.CouponUrl,
        CouponTKLWord: goodsDetailData.CouponTKLWord,
        RealAmount: goodsDetailData.RealAmount,
        ShopName: goodsDetailData.ShopName,
        ShopDsr: goodsDetailData.ShopDsr,
        SmallImages: goodsDetailData.SmallImages,
        Volume: goodsDetailData.Volume,
        UserType: goodsDetailData.UserType
      }

      if (this.loginState) {
        this.hanlderUnSearchPromise(GetTBKProductInfoSuper(postData), goodsDetailData.NumId)
      } else {
        this.hanlderUnSearchPromise(GetTBKProductInfoSuperNologin(postData), goodsDetailData.NumId)
      }
    },

    // 处理免搜录入成功返回
    hanlderUnSearchPromise(resPromise, numId) {
      resPromise
        .then((res) => {
          this.$toast.clear()
          this.$router.push({
            name: 'unSearchDetail',
            query: {
              id: res.Data,
              numId: numId,
              isHigh: true
            }
          })
        })
        .catch((res) => {
          this.$toast.clear()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },
    // 获取内容列表接口
    GetH5ContentList() {
      return H5ContentListGet({ page: 1, rows: 2 })
        .then((res) => {
          this.h5ContentList = res.DataList
          this.isLoadH5ContentList = true
        })
        .catch((res) => {
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },
    // 获取淘礼金商品列表接口
    GetTLJProductList() {
      return GetTLJProductList({ page: this.partOneData.page })
        .then((res) => {
          this.partOneData.list = [...this.partOneData.list, ...res.Data.rows]
          this.partOneData.page++
          this.partOneData.loading = false
          if (!this.partOneData.isLoad) {
            this.partOneData.isLoad = true
          }
          if (res.Data.rows.length < 10) {
            this.partOneData.finished = true
            // this.isShowCollectCouponsPart = true
            // this.datalist[this.active].loading = true
            // this.fetchData()
          }
        })
        .catch((res) => {
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },

    // 进入品质专区详情页
    entoDetailPage(productID, isFreeCard) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: isFreeCard
        }
      })
    },

    // 进入金牌补贴专区详情页
    entotTLJDetailPage(NumID) {
      this.$router.push({
        name: 'cashGiftGoodsDetail',
        query: {
          id: NumID,
          tljOrderType: 1
        }
      })
    },

    linkToDetailH5Content({ id = '' }) {
      if (!this.loginState) {
        this.unLoginModal()
        return
      }
      this.$router.push({ name: 'carefullyChosenDetail', query: { id: id } })
    },

    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    }
  },

  // 记录离开时的位置
  beforeRouteLeave(to, from, next) {
    // 保存滚动条元素div的scrollTop值
    this.scrollY = this.$refs.container.scrollTop
    next()
  },

  // 为div元素重新设置保存的scrollTop值
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(function() {
        let routeNames = ['goodsDetail', 'cashGiftGoodsDetail', 'unSearchDetail', 'carefullyChosenPage']
        if (routeNames.indexOf(from.name) !== -1 && vm.container) {
          vm.$refs.container.scrollTop = vm.scrollY
          vm.GetTLJProductList()
        } else {
          vm.$nextTick(() => {
            vm.isShowCollectCouponsPart = false
            vm.reFetchPage()
          })
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.customTitle {
  position: relative;
  font-size: vw(15);
  font-weight: 700;
  padding: vw(12) 0 vw(12) vw(23);
  box-sizing: border-box;
  &::before {
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    transform: translate(10px, -50%);
    width: vw(5);
    height: vw(15);
    background: #ff5f5f;
    border-radius: vw(3);
  }
}
.container {
  background-color: #fff;
}
.UnSearchCenter {
  .content {
    display: flex;
    // align-items: center;
    flex-direction: column;
    position: relative;
    width: 100%;
    // background: #fff;
    // background: linear-gradient(to bottom, #f1f1f1 0,#ffffff 300px, #ffffff);
    > div {
      flex-shrink: 0;
    }
  }
  .carefullyChosen {
    .carefullyChosenList {
      width: vw(360);
      margin: 0 auto vw(26);
      background-color: #fff;
      border-radius: vw(5);
      padding: 0 vw(10);
      box-sizing: border-box;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .CarefullyChosenItem {
        border-bottom: vw(1) solid rgba(242, 242, 242, 0.8);
      }
      .checkMoreBox {
        display: flex;
        justify-content: space-around;
        height: vw(42);
        .subCon {
          display: flex;
          align-items: center;
          color: #999999;
          font-size: vw(12);
        }
      }
    }
  }
  .modelThree {
    width: 100%;
    box-sizing: border-box;
    // overflow: hidden;
    // margin-bottom: vw(26);
    .modelThreeTitle {
      display: flex;
      align-items: center;
      margin: 0 0 vw(15);
      padding: 0 vw(8);
      .clockIcon {
        flex-shrink: 0;
        width: vw(18);
        height: vw(18);
        margin-right: vw(5);
      }
      .time {
        font-size: vw(14);
        line-height: vw(14);
        font-weight: 700;
      }
    }
    .listPart {
      .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 vw(8);
      }
      .waterfallList {
        display: flex;
        justify-content: space-between;
        // margin: 0 vw(8);
        // width: vw(360);
        padding: 0 vw(8);
        margin: 0 auto;
        .hot-block {
          width: vw(175);
          .hot-block-item:last-child {
            > div {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .listPart2 {
    width: 100%;
    // background: linear-gradient(180deg, #fff 0, #f1f1f1 300px, #f1f1f1);
    // background-color: #f1f1f1;
    .listTitleBox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: relative;
      font-size: vw(16);
      font-weight: 700;
      color: #2e2e2e;
      background-color: #fff;
      padding-bottom: vw(10);
      .listTitle {
        position: relative;
        .title {
          position: relative;
          z-index: 2;
        }
        .modifyOne {
          position: absolute;
          left: vw(-12);
          bottom: vw(-2);
          display: inline-block;
          width: vw(18);
          height: vw(18);
          opacity: 0.5;
          background: #ffdc52;
          border-radius: 50%;
          z-index: 1;
        }
        .modifyTwo {
          position: absolute;
          right: vw(-6);
          top: vw(-2);
          display: inline-block;
          width: vw(15);
          height: vw(15);
          opacity: 0.28;
          background: #fca8a8;
          border-radius: 50%;
        }
      }
    }
    .tabsBannerBox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: #fff;
      box-sizing: border-box;
    }
    .tabsBanner {
      display: block;
      width: 96%;
      margin: vw(10) auto;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 2%;
      // background: linear-gradient(to bottom, #fff 0, #f1f1f1 300px, #f1f1f1);
    }
  }
  .emptyBox {
    width: 100%;
    height: vw(52);
  }
}
</style>
